<div [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<label>{{(isUpperJaw ? 'Upper jaw' : 'Lower jaw') | translate}}</label>
		<div formGroupName="{{jawFormControlName}}">
			<mat-radio-group formControlName="option">
				<mat-radio-button value="{{ThreeOptionsAnswer.YES}}">{{ answerRecord[ThreeOptionsAnswer.YES] | translate}}</mat-radio-button>
				<mat-radio-button value="{{ThreeOptionsAnswer.NO}}">{{ answerRecord[ThreeOptionsAnswer.NO] | translate}}</mat-radio-button>
				<div>
					<mat-radio-button value="{{ThreeOptionsAnswer.OTHER}}">{{ answerRecord[ThreeOptionsAnswer.OTHER] | translate}}</mat-radio-button>
					<mat-form-field>
						<input matInput formControlName="text">
						<mat-error>{{"please fill in" | translate}}</mat-error>
					</mat-form-field>
				</div>
			</mat-radio-group>
		</div>
	</div>
</div>


